import {AxiosProgressEvent} from 'axios';

import {
	PostRequestUploadFile,
	PostRequestUploadFileParams,
	PostRequestUploadFileResponse,
} from 'domain/usecases';

import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

export class RemoteRequestPostUploadFile implements PostRequestUploadFile {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostRequestUploadFileResponse>,
		private readonly onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
	) {}

	async post(params: PostRequestUploadFileParams): Promise<PostRequestUploadFileResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url.replace(':nuControle', params?.nuControle ?? ''),
			method: 'post',
			body: {arquivo: params.file},
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			responseType: 'json',
			onUploadProgress: this.onUploadProgress,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
